export async function expandToAdjacentParagraph(
  context: Word.RequestContext,
  anchorRange: Word.Range,
  direction: "previous" | "next",
): Promise<Word.Range> {
  const anchorParagraph = anchorRange.paragraphs.getFirst();
  const adjacentParagraph =
    direction === "previous"
      ? anchorParagraph.getPrevious()
      : anchorParagraph.getNext();
  adjacentParagraph.load("isNullObject");
  await context.sync();

  if (!adjacentParagraph.isNullObject) {
    return direction === "previous"
      ? adjacentParagraph.getRange().expandTo(anchorParagraph.getRange())
      : anchorParagraph.getRange().expandTo(adjacentParagraph.getRange());
  }
  return anchorParagraph.getRange();
}
